import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import Swiper from '../../../../node_modules/swiper/core/core.js';
import '../../../../node_modules/swiper/shared/dom.js';
import Pagination from '../../../../node_modules/swiper/modules/pagination/pagination.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import css_248z$1 from '../../typography/headings/card-heading/card-heading.scss.js';
import css_248z$2 from '../../typography/texts/card-text/card-text.scss.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './preview-cards.scss.js';
import css_248z$3 from '../../atoms/buttons/generic-button/styles/secondary-button.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
class PreviewCards extends LitElementWithUtils {
    constructor() {
        super();
        this._resizeObserver = null;
        this.rtl = false;
        this.onHoverBg = false;
        this._query = '(max-width: 1365px)';
        this._isLessLaptop = false;
    }
    setSimpleCardHeight(simpleCard, height) {
        const card = simpleCard;
        card.style.height = `${height}px`;
    }
    syncSimpleCardHeight() {
        var _a, _b, _c, _d;
        let firstCategoryTile = null;
        let lastCategoryTile = null;
        const swiperWrapper = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper-wrapper');
        if (swiperWrapper && swiperWrapper.children.length >= 3) {
            const firstSlide = swiperWrapper.children[0];
            const lastSlide = swiperWrapper.children[swiperWrapper.children.length - 1];
            firstCategoryTile = firstSlide === null || firstSlide === void 0 ? void 0 : firstSlide.querySelector('category-tile-small');
            lastCategoryTile = lastSlide === null || lastSlide === void 0 ? void 0 : lastSlide.querySelector('category-tile-small');
        }
        if (!firstCategoryTile || !lastCategoryTile) {
            const slotsContainer = ((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('slot[name="slides-container"]')) || null;
            if (!slotsContainer)
                return;
            const assignedElements = slotsContainer.assignedElements();
            if (assignedElements.length < 3)
                return;
            const lastElement = assignedElements[assignedElements.length - 1];
            const firstElement = assignedElements[0];
            lastCategoryTile = lastElement === null || lastElement === void 0 ? void 0 : lastElement.querySelector('category-tile-small');
            firstCategoryTile = firstElement === null || firstElement === void 0 ? void 0 : firstElement.querySelector('category-tile-small');
        }
        if (!lastCategoryTile || !firstCategoryTile)
            return;
        const isSimpleCard = lastCategoryTile.hasAttribute('simplecard') ||
            lastCategoryTile.hasAttribute('simpleCard');
        if (!isSimpleCard)
            return;
        const simpleCardTile = (_c = lastCategoryTile.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.small-tile');
        const firstCardTile = (_d = firstCategoryTile.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.small-tile');
        if (simpleCardTile && firstCardTile && firstCardTile.clientHeight > 0) {
            this.setSimpleCardHeight(simpleCardTile, firstCardTile.clientHeight);
        }
    }
    setupSimpleCardHeightObserver() {
        var _a, _b, _c;
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            this._resizeObserver = null;
        }
        let firstCategoryTile = null;
        const swiperWrapper = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper-wrapper');
        if (swiperWrapper && swiperWrapper.children.length > 0) {
            const firstSlide = swiperWrapper.children[0];
            firstCategoryTile = firstSlide === null || firstSlide === void 0 ? void 0 : firstSlide.querySelector('category-tile-small');
        }
        if (!firstCategoryTile) {
            const slotsContainer = ((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('slot[name="slides-container"]')) || null;
            if (slotsContainer) {
                const assignedElements = slotsContainer.assignedElements();
                if (assignedElements.length > 0) {
                    const firstElement = assignedElements[0];
                    firstCategoryTile = firstElement === null || firstElement === void 0 ? void 0 : firstElement.querySelector('category-tile-small');
                }
            }
        }
        if (!firstCategoryTile)
            return;
        const firstCardTile = (_c = firstCategoryTile.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.small-tile');
        if (!firstCardTile)
            return;
        this._resizeObserver = new ResizeObserver(() => {
            this.syncSimpleCardHeight();
        });
        this._resizeObserver.observe(firstCardTile);
    }
    transformSlotsIntoSlides() {
        const slidesWrapper = this.shadowRoot.querySelector('.swiper-wrapper');
        const slotsContainer = this.shadowRoot.querySelector('slot[name="slides-container"]');
        const assignedElements = slotsContainer.assignedElements();
        assignedElements.forEach(slot => {
            slidesWrapper.append(slot);
        });
    }
    firstUpdated() {
        requestAnimationFrame(() => {
            setTimeout(() => {
                this.syncSimpleCardHeight();
                this.setupSimpleCardHeightObserver();
            }, 400);
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        }
    }
    updated() {
        var _a, _b, _c, _d;
        const swiperContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper');
        const swiperPagination = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.swiper-pagination');
        if (this._isLessLaptop) {
            if (swiperContainer && (!this._swiper || ((_c = this._swiper) === null || _c === void 0 ? void 0 : _c.destroyed))) {
                this.transformSlotsIntoSlides();
                this._swiper = new Swiper(swiperContainer, {
                    modules: [Pagination],
                    preloadImages: false,
                    lazy: true,
                    pagination: {
                        el: swiperPagination,
                        type: 'bullets',
                        clickable: true,
                    },
                    slidesPerView: 1.1,
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            slidesPerGroup: 2,
                            slidesPerView: 2.2,
                            spaceBetween: 24,
                        },
                    },
                });
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        this.syncSimpleCardHeight();
                    }, 300);
                });
            }
        }
        else {
            (_d = this._swiper) === null || _d === void 0 ? void 0 : _d.destroy(true, true);
            requestAnimationFrame(() => {
                setTimeout(() => {
                    this.syncSimpleCardHeight();
                }, 200);
            });
        }
    }
    _handleMediaQuery(event) {
        this._isLessLaptop = event.detail.value;
        this.requestUpdate();
    }
    render() {
        var _a;
        return $ `<div class="preview-cards ${this.rtl || isRTL() ? 'rtl' : ''} ${(_a = this
            .utilityClasses) !== null && _a !== void 0 ? _a : ''}"><slot name="big-card"></slot><div class="swiper small-cards"><div class="swiper-wrapper"></div><slot name="slides-container"></slot><div class="swiper-pagination"></div></div><lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query></div>`;
    }
}
PreviewCards.styles = [
    LitElementWithUtils.styles || [],
    css_248z,
    css_248z$1,
    css_248z$2,
    css_248z$3,
];
__decorate([
    e({ type: Boolean })
], PreviewCards.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], PreviewCards.prototype, "onHoverBg", void 0);
customElements.define('preview-cards', PreviewCards);

export { PreviewCards };
